module.exports = __webpack_public_path__ + "static/media/green-template-big.babb3158.png";